import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import { useMounted } from '@vueuse/core';

import PictureComp from '@/components/picture/PictureComp.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import InfiniteBiScroll from '@/components/list/InfiniteBiScroll.vue';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { ArticleClickedData, BlockArticle } from '@/features/editorial/types/editorial-types';

import { useArticleTimeline, PAGE_SIZE } from '@/features/editorial/composables/useArticleTimeline';
import { formatDateTime, isToday, isYesterday } from '@/helpers/date-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import type { LoadMorePayload } from '@/helpers/composables/useBiScroll';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleTimeline',
  emits: ["articleClicked", "authorClicked", "loadStarted"],
  setup(__props, { emit: emits }: { emit: ({
	(e: 'articleClicked', data: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
	(e: 'loadStarted'): void;
}), expose: any, slots: any, attrs: any }) {



const { articleTimeline, loading, totalBucketCount, fetchMoreArticles, fetchPrevArticles } = useArticleTimeline();
const { tc } = useI18n();
const isMounted = useMounted();

const { language, country } = storeToRefs(useLanguageStore());

function formatBucketDate(date: Date | string) {
	const bucketDate = new Date(date);

	if (isMounted.value) {
		if (isToday(bucketDate)) return tc('WEBAPP_TODAY');
		if (isYesterday(bucketDate)) return tc('WEBAPP_YESTERDAY');
	}

	return formatDateTime(bucketDate, language.value, country.value, {});
}

function handleArticleClick(article: BlockArticle, index: number) {
	const articleData = {
		slug: article.content.fullPath,
		articleType: article.content.articleType,
		index,
	};

	emits('articleClicked', articleData);
}

async function handleLoadNext({ event }: LoadMorePayload) {
	emits('loadStarted');
	await fetchMoreArticles();
	event.target.complete();
}

async function handleLoadPrev({ event }: LoadMorePayload) {
	emits('loadStarted');
	await fetchPrevArticles();
	event.target.complete();
}

return { __sfc: true,emits, articleTimeline, loading, totalBucketCount, fetchMoreArticles, fetchPrevArticles, tc, isMounted, language, country, formatBucketDate, handleArticleClick, handleLoadNext, handleLoadPrev, PictureComp, HiddenHorizontalScrollbar, InfiniteBiScroll, PAGE_SIZE }
}

})